/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MobileToggleSwitch.scss';

import React from 'react';

const MobileToggleSwitch = ({ onChange, selection, id }) => (
  <label className="mobile-switch">
    <input
      checked={selection}
      onChange={onChange}
      id={`switchValue-${id}`}
      type="checkbox"
    />
    <span className="mobile-slider round" />
  </label>
);

export default MobileToggleSwitch;
